import React from 'react'
export const TemplateContainer = React.lazy(() =>
    import('./TemplateContainerWrapper').then(module => ({ default: module.TemplateContainer }))
)
